const regexp = /^([a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}|[a-zA-Z]{3}[0-9]{3})$/
const carsAndMotorbikesRegex = /^([a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}|[a-zA-Z]{3}[0-9]{3}|[a-zA-Z]{0,1}[0-9]{3}[a-zA-Z]{3})$/

export default function validatePatente(patente, includeMotorbikes = true) {
  if (!includeMotorbikes) return regexp.test(patente)

  return carsAndMotorbikesRegex.test(patente)
}
